import React from 'react';
import LegalLayout from '../../layouts/LegalLayout/LegalLayout';
import styles from './Legal.module.scss';

const Prohibitions = () => {
    return (
        <LegalLayout title="STBL Prohibited Activities Policy">
            <div className={styles.legalContent}>
                <section className={styles.section}>
                    <p>
                        To ensure the integrity, legality, and security of our platform, STBL maintains a strict policy regarding the types of businesses, transactions, and users we support. The following activities and uses are strictly prohibited on our platform.
                    </p>
                    <p>
                        This policy applies to all users, businesses, and transactions and is subject to change based on regulatory, legal, and operational requirements.
                    </p>

                    <h3>1. Prohibited Business Types</h3>
                    <p>The following categories of businesses or activities are not allowed to access or use our platform under any circumstances:</p>
                    <ul>
                        <li>Any business involved in illegal activities or products</li>
                        <li>Production or distribution of controlled substances without appropriate licensing</li>
                        <li>Human trafficking, prostitution, or escort services</li>
                        <li>Sale or distribution of counterfeit goods</li>
                        <li>Deceptive, misleading, or predatory business models (e.g., pyramid or Ponzi schemes)</li>
                        <li>Activities involving illegal content, such as child exploitation materials</li>
                    </ul>

                    <h3>2. Restricted Business Activities</h3>
                    <p>Some businesses may be allowed only with prior review and approval. These include, but are not limited to:</p>
                    <ul>
                        <li>Money Service Businesses (MSBs)</li>
                        <li>Cryptocurrency-related services or exchanges</li>
                        <li>Gambling or fantasy sports operators</li>
                        <li>Charitable organizations or NGOs</li>
                        <li>Adult content platforms or online tipping/streaming services</li>
                        <li>Precious metal dealers</li>
                    </ul>
                    <p>Businesses in these categories must demonstrate proper licensing, regulatory compliance, and strong internal controls.</p>

                    <h3>3. Prohibited Transactions and Usage</h3>
                    <p>The following types of transactions or platform use are not allowed:</p>
                    <ul>
                        <li>Purchase or sale of drugs, black-market items, or substances prohibited by law</li>
                        <li>Use of stolen, counterfeit, or unauthorized financial information</li>
                        <li>Payments for or involvement in cybercrime or hacking services</li>
                        <li>Transactions related to weapons, ammunition (Corporate)</li>
                        <li>Unlicensed internet pharmacies or auction sites</li>
                        <li>Unlawful access to or trade in personal or confidential data</li>
                        <li>Services involving payday loans or unlicensed lending</li>
                        <li>Transactions related to the trade of endangered wildlife or their products</li>
                    </ul>

                    <h3>4. Geographic Restrictions</h3>
                    <p>Access to or use of our services is restricted in the following countries due to legal and regulatory considerations:</p>
                    <ul>
                        <li>Cuba</li>
                        <li>Iran</li>
                        <li>North Korea</li>
                        <li>Russia</li>
                        <li>Syria</li>
                        <li>Venezuela</li>
                        <li>Myanmar</li>
                        <li>Ukraine (including Crimea, Donetsk, and Luhansk regions)</li>
                    </ul>
                    <p>Other jurisdictions may be restricted at our discretion or based on sanctions or watchlists (e.g., FATF).</p>

                    <h3>5. Enforcement and Monitoring</h3>
                    <p>
                        STBL reserves the right to monitor all activity. We may suspend or terminate accounts found to be engaging in any of the prohibited activities listed above.
                    </p>
                    <p>
                        Violations may also be reported to appropriate law enforcement or regulatory agencies where required.
                    </p>

                    <div className={styles.importantNote}>
                        <h4>Contact Us</h4>
                        <p>
                            If you have questions about whether your business or transaction is allowed, please contact our compliance team at <a href="mailto:support@stbl.io">support@stbl.io</a>.
                        </p>
                    </div>
                </section>
            </div>
        </LegalLayout>
    );
};

export default Prohibitions;
